import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-center row pb-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "line col-1" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "line col-1" }, null, -1)
const _hoisted_4 = {
  class: "stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid",
  id: "kt_create_account_stepper",
  ref: "verticalWizardRef"
}
const _hoisted_5 = {
  class: "d-flex justify-content-center bg-white rounded justify-content-xl-start flex-row-auto w-100 w-xl-300px w-xxl-400px me-9",
  style: {"display":"none !important"}
}
const _hoisted_6 = { class: "px-6 px-lg-10 px-xxl-15 py-20" }
const _hoisted_7 = { class: "stepper-nav" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">1</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Recruitment Strategy</h3></div>", 3)
const _hoisted_11 = [
  _hoisted_8
]
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">2</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">PHI</h3></div>", 3)
const _hoisted_15 = [
  _hoisted_12
]
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">3</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Compensation</h3></div>", 3)
const _hoisted_19 = [
  _hoisted_16
]
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">4</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title\">Completed</h3></div></div>", 1)
const _hoisted_21 = { class: "d-flex flex-row-fluid flex-center bg-white rounded" }
const _hoisted_22 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_23 = { "data-kt-stepper-element": "content" }
const _hoisted_24 = { "data-kt-stepper-element": "content" }
const _hoisted_25 = { "data-kt-stepper-element": "content" }
const _hoisted_26 = { class: "d-flex flex-stack pt-10" }
const _hoisted_27 = { class: "mr-2" }
const _hoisted_28 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_29 = { class: "indicator-label" }
const _hoisted_30 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_32 = {
  key: 1,
  id: "buttonSubmit",
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_33 = { class: "svg-icon svg-icon-4 ms-1 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NoteSection = _resolveComponent("NoteSection")!
  const _component_Step1 = _resolveComponent("Step1")!
  const _component_Step2 = _resolveComponent("Step2")!
  const _component_Step3 = _resolveComponent("Step3")!
  const _component_Step4 = _resolveComponent("Step4")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NoteSection, { type: "Recruitment" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "col-3 cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.jumpToStep(0)))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["badge", `${ _ctx.currentStepIndex == 1?   `custom-steper-active badge-highligthed `:` badge-normal ` }`])
        }, _toDisplayString(_ctx.currentStepIndex > 1? `✔`: `1`), 3),
        _createElementVNode("span", {
          class: _normalizeClass(["font-weight-bold inner_heading subtitle-color-gray", `${ _ctx.currentStepIndex == 1?   `custom-steper-active`:`` }`])
        }, " Recruitment Strategy ", 2)
      ]),
      _hoisted_2,
      _createElementVNode("div", {
        class: "col-3 cursor-pointer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.jumpToStep(1)))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["badge badge-light", `${ _ctx.currentStepIndex == 2?   `custom-steper-active badge-highligthed `:`badge-normal` }`])
        }, _toDisplayString(_ctx.currentStepIndex > 2? `✔`: `2`), 3),
        _createElementVNode("span", {
          class: _normalizeClass(["font-weight-bold inner_heading subtitle-color-gray", `${ _ctx.currentStepIndex == 2?   `custom-steper-active`:`` }`])
        }, " PHI ", 2)
      ]),
      _hoisted_3,
      _createElementVNode("div", {
        class: "col-3 cursor-pointer",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.jumpToStep(2)))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["badge badge-light", `${ _ctx.currentStepIndex == 3?   `custom-steper-active badge-highligthed `:`badge-normal ` }`])
        }, _toDisplayString(_ctx.currentStepIndex > 3? `✔`: `3`), 3),
        _createElementVNode("span", {
          class: _normalizeClass(["font-weight-bold inner_heading subtitle-color-gray", `${ _ctx.currentStepIndex == 3?   `custom-steper-active`:`` }`])
        }, " Compensation ", 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "stepper-item current cursor-pointer",
              "data-kt-stepper-element": "nav",
              "data-kt-stepper-action": "no-step",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.jumpToStep(0)))
            }, _hoisted_11),
            _createElementVNode("div", {
              class: "stepper-item cursor-pointer",
              "data-kt-stepper-element": "nav",
              "data-kt-stepper-action": "no-step",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.jumpToStep(1)))
            }, _hoisted_15),
            _createElementVNode("div", {
              class: "stepper-item cursor-pointer",
              "data-kt-stepper-element": "nav",
              "data-kt-stepper-action": "no-step",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.jumpToStep(2)))
            }, _hoisted_19),
            _hoisted_20
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("form", {
          class: "py-20 w-100 px-9",
          novalidate: "novalidate",
          id: "kt_create_account_form",
          onSubmit: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
        }, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_Step1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_Step2)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_Step3)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_Step4)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-lg btn-light-primary me-3",
                "data-kt-stepper-action": "previous",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args)))
              }, [
                _createElementVNode("span", _hoisted_28, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr063.svg" })
                ]),
                _createTextVNode(" Back ")
              ])
            ]),
            _createElementVNode("div", null, [
              (_ctx.currentStepIndex === _ctx.totalSteps)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-lg btn-primary me-3",
                    "data-kt-stepper-action": "submit",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.formSubmit()))
                  }, [
                    _createElementVNode("span", _hoisted_29, [
                      _createTextVNode(" Submit "),
                      _createElementVNode("span", _hoisted_30, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                      ])
                    ]),
                    _hoisted_31
                  ]))
                : (_openBlock(), _createElementBlock("button", _hoisted_32, [
                    _createTextVNode(" Save & Continue "),
                    _createElementVNode("span", _hoisted_33, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ])
                  ]))
            ])
          ])
        ], 32)
      ])
    ], 512)
  ], 64))
}